var t=function(t,e){return("string"==typeof e||"number"==typeof e||"symbol"==typeof e)&&e in t};export{t as isKeyOf};
//# sourceMappingURL=isKeyOf.js.map
